import React from 'react';
import styled from 'styled-components';

import { Nullable } from '@tager/web-core';

type Props = {
  title: Nullable<string>;
};

const Title = ({ title }: Props) => {
  return <Component>{title}</Component>;
};

export default Title;

const Component = styled.h1`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;
